import { render, staticRenderFns } from "./MoneyMatching.vue?vue&type=template&id=16d2b8ce&"
import script from "./MoneyMatching.vue?vue&type=script&lang=js&"
export * from "./MoneyMatching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports